import React, { useState } from 'react';
import { PopupModal } from '../../../Modals/Index';
import './Style.css';

import BlockIcon from '@material-ui/icons/Block';

import { MechantDetails } from '../..';

const Index = () => {
    const [showdetails, setShowdetails] = useState(false);
    return (
        <>
            <MechantDetails
                state={showdetails}
                setStateFalse={() => {
                    setShowdetails((prev) => !prev);
                }}
            />
            <div
                style={{
                    overflowY: 'hidden',
                    overflowX: 'auto',
                    padding: '1rem',
                }}
            >
                <table className="manage_merchants_table">
                    <thead className="manage_merchants_table_head">
                        <tr className="manage_merchants_table_head_row">
                            <td className="manage_merchants_table_head_data">ID</td>
                            <td className="manage_merchants_table_head_data">Name</td>
                            <td className="manage_merchants_table_head_data">City</td>
                            <td className="manage_merchants_table_head_data">Phone</td>
                            <td className="manage_merchants_table_head_data">Block</td>
                        </tr>
                    </thead>
                    <tbody className="manage_merchants_table_body">
                        <Component
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            name="Joe Daniels"
                            city="Beckham"
                            phone="+91-0987654321"
                            id="001"
                        />
                        <Component
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            name="Joe Daniels"
                            city="Beckham"
                            phone="+91-0987654321"
                            id="002"
                        />
                        <Component
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            name="Joe Daniels"
                            city="Beckham"
                            phone="+91-0987654321"
                            id="003"
                        />
                        <Component
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            name="Joe Daniels"
                            city="Beckham"
                            phone="+91-0987654321"
                            id="004"
                        />
                        <Component
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            name="Joe Daniels"
                            city="Beckham"
                            phone="+91-0987654321"
                            id="005"
                        />
                        <Component
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            name="Joe Daniels"
                            city="Beckham"
                            phone="+91-0987654321"
                            id="006"
                        />
                    </tbody>
                </table>
            </div>
        </>
    );
};

const Component = ({ clickhandler, name, phone, city, id }) => {
    const [modal, setModal] = useState(false);
    const [reason, setReason] = useState('');
    return (
        <>
            <PopupModal
                state={modal}
                setStateFalse={() => {
                    setModal((prev) => !prev);
                }}
            >
                <div style={{ width: 'max-content' }} className="popupConatiner">
                    <div className="home_head flex-start">
                        <div className="home_head">
                            <div>
                                <h2 className="home_heading">Block {name}</h2>
                            </div>
                        </div>
                    </div>
                    <form className="merch_table-popup" action={`submit`}>
                        <p className="labeled_input_p">Reason:</p>
                        <textarea
                            value={reason}
                            changeHandler={(e) => {
                                setReason(e.target.value);
                            }}
                            placeholder="State Reason Here"
                            className="merch_table_textarea"
                        ></textarea>
                        <div className="merch_table-popup_footer">
                            <button
                                type="reset"
                                onClick={() => {
                                    setModal((prev) => !prev);
                                }}
                                className="btn-gray"
                                style={{ marginRight: '1rem' }}
                            >
                                <p>Close</p>
                            </button>
                            <button
                                onClick={() => {
                                    alert('Blocked');
                                }}
                                type="submit"
                                className="btn-orange"
                            >
                                <p>Block</p>
                            </button>
                        </div>
                    </form>
                </div>
            </PopupModal>
            <tr className="manage_merchants_table_body_row">
                <td onClick={clickhandler} className="manage_merchants_table_body_data">
                    {id}
                </td>
                <td onClick={clickhandler} className="manage_merchants_table_body_data">
                    {name}
                </td>
                <td onClick={clickhandler} className="manage_merchants_table_body_data">
                    {city}
                </td>
                <td onClick={clickhandler} className="manage_merchants_table_body_data">
                    {phone}
                </td>

                <td className="manage_merchants_table_body_data">
                    <div
                        onClick={() => {
                            setModal((prev) => !prev);
                        }}
                        className="merch_table_icons"
                    >
                        <BlockIcon className="merch_table_icon" />
                    </div>
                </td>
            </tr>
        </>
    );
};

export default Index;
